import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { QuillModule } from 'ngx-quill';
import { ChatAvatarModule } from '../chat-avatar/chat-avatar.module';
import { ChatInputModule } from '../chat-input/chat-input.module';
import { ChatMessageComponent } from './chat-message.component';

@NgModule({
  declarations: [ChatMessageComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatTooltipModule,
    MatMenuModule,
    FontAwesomeModule,
    QuillModule,

    ChatAvatarModule,
    ChatInputModule,
  ],
  exports: [ChatMessageComponent],
})
export class ChatMessageModule {}
